import { Button } from '@evaneos/b2b-ui/legacy';
import { Component, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { AllTranslationKeys } from '../../../../shared/intl/types';

import s from './ModalContent.css';

type Props = PropsWithChildren<{
    buttonAction: () => void | null;
    buttonDisabled?: boolean;
    onClose: () => void;
    type: string;
}>;

export class ModalContent extends Component<Props> {
    constructor(props: Props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(): void {
        window.addEventListener('keydown', this.handleSubmit);
    }

    componentWillUnmount(): void {
        window.removeEventListener('keydown', this.handleSubmit);
    }

    handleSubmit(e: KeyboardEvent): void {
        if (e.key === 'Enter') {
            this.props.buttonAction();
        }
    }

    render(): JSX.Element {
        const { type, children, onClose, buttonDisabled, buttonAction } = this.props;

        return (
            <div>
                <div className={s.titleContainer}>
                    <h2>
                        <FormattedMessage id={`dossier.${type}.request` as AllTranslationKeys} />
                    </h2>
                    <p>
                        <FormattedMessage id={`dossier.${type}.message` as AllTranslationKeys} />
                    </p>
                </div>
                {children}
                <div className={s.modalButtons}>
                    <Button priority="secondary" onClick={onClose}>
                        <FormattedMessage id="form.cancel" />
                    </Button>
                    <Button disabled={buttonDisabled} onClick={buttonAction} className={s.submit}>
                        <FormattedMessage id="form.submit" />
                    </Button>
                </div>
            </div>
        );
    }
}
